export default "__VITE_ASSET__Drt0tt34__"